import React from 'react'

import { INumberProps } from 'core-components/library/inputs/Number'
import { VisualAudienceExtended } from 'core/components/shared/ui/VisualAudienceExtended'
import { OnboardingNumberInput } from 'onboarding/components/ui/theme'

import styles from '../PartnerShipNA.module.scss'

import { MAX_PERCENT, MIN_PERCENT } from './constants'
import { IPartnerShipNA } from './types'

interface IProps {
  onChange: (field: string, number?: boolean) => (value: string) => void
  item: IPartnerShipNA
  writeAudience: IObjectAny
  disabled?: boolean
}

export const SellingMethodsNa = ({ onChange, item, writeAudience, disabled }: IProps) => {
  return (
    <div>
      <div className={styles.text__title}>
        Selling Methods <div className={styles.text__rule}>{`(Applies to T1 & T2 Reseller)`}</div>
      </div>
      <div className={styles.root}>
        <div className={styles.column__selling}>
          <VisualAudienceExtended<INumberProps>
            component={OnboardingNumberInput}
            write={writeAudience}
            margin={'md'}
            label={'Direct Sales Force (%)'}
            min={MIN_PERCENT}
            max={MAX_PERCENT}
            value={item.DirectSalesForce ?? undefined}
            onChange={onChange('DirectSalesForce', true)}
            disabled={disabled}
          />
          <VisualAudienceExtended<INumberProps>
            component={OnboardingNumberInput}
            write={writeAudience}
            margin={'md'}
            label={'Marketplaces (%)'}
            min={MIN_PERCENT}
            max={MAX_PERCENT}
            value={item.Marketplace ?? undefined}
            onChange={onChange('Marketplace', true)}
            disabled={disabled}
          />
        </div>
        <div className={styles.column__selling}>
          <VisualAudienceExtended<INumberProps>
            component={OnboardingNumberInput}
            write={writeAudience}
            margin={'md'}
            label={'Own URL (%)'}
            min={MIN_PERCENT}
            max={MAX_PERCENT}
            value={item.OwnURL ?? undefined}
            onChange={onChange('OwnURL', true)}
            disabled={disabled}
          />
          <VisualAudienceExtended<INumberProps>
            component={OnboardingNumberInput}
            write={writeAudience}
            margin={'md'}
            label={'Total Selling Methods (%)'}
            min={MIN_PERCENT}
            max={MAX_PERCENT}
            value={item.TotalSellingMethods ?? undefined}
            onChange={onChange('TotalSellingMethods', true)}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  )
}
